import React from "react";
import Select, { components } from "react-select";

import downArrowSvg from "assets/img/arrow-down.svg";

interface DropdownProps {
  value: any;
  name?: string;
  options: any[];
  noOptionsMessage?: any;
  className?: string;
  classNamePrefix?: string;
  image?: string;
  placeholder?: string;
  containerStyles?: object;
  controlStyles?: object;
  onChange?: (newValue: any, action: object) => void;
  onInputChange?: (newValue: any, action: object) => void;
  isDisabled?: boolean;
  isSearchable?: boolean;
  onMenuOpen?: () => void;
  onMenuClose?: () => void;
  formatOptionLabel?: any;
  dataQa?: string;
  closeMenuOnSelect?: boolean;
  isMulti?: boolean;
  blurInputOnSelect?: boolean;
  noShadow?: boolean;
  backgroundFill?: boolean;
  placeholderStyles?: object;
  onMenuScrollToBottom?: () => void;
  hasDefaultAll?: boolean;
}

const Dropdown: React.FunctionComponent<DropdownProps> = ({
  backgroundFill,
  noShadow,
  containerStyles,
  controlStyles,
  dataQa,
  image = downArrowSvg,
  isSearchable = false,
  placeholderStyles,
  hasDefaultAll = false,
  options,
  ...restProps
}) => {
  const finalOptions = hasDefaultAll ? [{ label: "All", value: null }, ...options] : options;
  return (
  <Select
    blurInputOnSelect={true}
    styles={{
    container: (base, state) => ({
      ...base,
      fontSize: 12,
      fontWeight: 400,
      fontFamily: "Arial",
      minWidth: 160,
      zIndex: state.selectProps.menuIsOpen ? 2 : "auto",
    }),

    control: (base, state) => ({
      ...base,
      height: 44,
      minHeight: 44,
      padding: "0 14px",
      border: "1px solid #ddd",
      borderRadius: 16,
      backgroundColor: "#fff",
      boxShadow: "none",
      cursor: "pointer",
      "&:hover": {
        borderColor: "#ddd",
      },
    }),

    valueContainer: (base) => ({
      ...base,
      padding: 0,
      fontSize: 12,
      fontWeight: 400,
    }),

    placeholder: (base) => ({
      ...base,
      fontSize: 12,
      fontWeight: 400,
      color: "#4A4A4A",
    }),

    singleValue: (base) => ({
      ...base,
      fontSize: 12,
      fontWeight: 400,
      color: "#4A4A4A",
    }),

    multiValue: (base) => ({
      ...base,
      backgroundColor: "#f5f5f5",
      borderRadius: 12,
    }),

    multiValueLabel: (base) => ({
      ...base,
      fontSize: 11,
      fontWeight: 400,
      textOverflow: "ellipsis",
    }),

    indicatorSeparator: () => ({
      display: "none",
    }),

    dropdownIndicator: (base) => ({
      ...base,
      padding: 0,
      marginLeft: 8,
    }),

    menu: (base) => ({
      ...base,
      marginTop: 4,
      border: "1px solid #ddd",
      borderRadius: 6,
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      overflow: "hidden",
    }),

    menuList: (base) => ({
      ...base,
      padding: 0,
      maxHeight: 300,
    }),

    option: (base, state) => ({
      ...base,
      padding: "10px 15px",
      fontSize: 12,
      fontWeight: 400,
      cursor: "pointer",
      borderBottom: "1px solid #f5f5f5",
      backgroundColor: state.isFocused
        ? "#f7f7f7"
        : state.isSelected
        ? "#f0f0f0"
        : "#fff",
      color: "#333",
    }),
  }}
    components={{
      MultiValueRemove: (multiValueProps) =>
        components.MultiValueRemove && (
          <span
            data-qa={(multiValueProps as any).data["data-qa"] + "-remove"}
            style={{ display: "flex", borderRadius: "16px", }}
          >
            <components.MultiValueRemove {...multiValueProps} />
          </span>
        ),
      DropdownIndicator: (dropdownProps) =>
        components.DropdownIndicator && (
          <span data-qa={dataQa}>
            <components.DropdownIndicator {...dropdownProps}>
              <img src={image} alt="" />
            </components.DropdownIndicator>
          </span>
        ),
      Option: (optionProps) => (
        <span data-qa={(optionProps as any).data["data-qa"]}>
          <components.Option {...optionProps} />
        </span>
      ),
      Placeholder: (placeholderProps) => (
        <div>
          <components.Placeholder {...placeholderProps} />
        </div>
      ),
    }}
    isSearchable={isSearchable}
    options={finalOptions}
    {...restProps}
    data-qa={dataQa}
  />
);
};

export default Dropdown;
